<template>
  <div class="view_main" id="view_main">
    <div class="left_line_move"></div>
    <div class="right_line_move"></div>
    <div class="view_top">
      <div class="top_logo"></div>
      <div class="top_time">
        <span class="time-text">{{ nowTime }}</span>
        <span class="date-text">{{ nowDate }}</span>
        <span class="week-text">{{ nowWeek }}</span>
      </div>
    </div>
    <div class="view_left_line"></div>
    <div class="view_left">
      <div class="left_top">
        <img class="left_top_icon" src="@/assets/images/common/union.png" />
        <span class="left_top_title">今日各类访客数据/人</span>
      </div>
      <div class="left_middle">
        <div
          class="middle_item"
          v-for="(item, index) in dataJsonInfo.todayVisitorsArr"
          :key="item.name + index"
        >
          <div
            class="item_title"
            :class="{
              'bg-wmy': item.type === 'wmy',
              'bg-kdy': item.type === 'kdy',
              'bg-aikm': item.type === 'aikm',
              'bg-zh': item.type === 'zh',
              'bg-ggqy': item.type === 'ggqy'
            }"
          >
            {{ item.name }}
          </div>
          <div class="item_number">
            <transition-group name="list-complete" tag="p">
              <span :key="item.value" class="list-complete-item">{{
                item.value
              }}</span>
            </transition-group>
          </div>
          <img :src="getImgUrl(item.type)" class="item_bg_img" alt="" />
        </div>
      </div>
      <div class="left_echarts">
        <div id="pieEchartsRef" ref="pieEchartsRef"></div>
        <div class="echarts_title">今日各类访客通行占比</div>
      </div>
    </div>
    <div class="china_map">
      <div class="view_map_top">
        <div class="map_top_bg"></div>
        <div class="top_bg"></div>
        <div class="today_title">
          今日美团外卖骑手极速验证人数
        </div>
        <div class="today_num">
          <span
            v-for="(num, index) in addCommas(
              dataJsonInfo.todayMeituanVerifyNum
            )"
            :key="num + index"
            :class="num !== ',' ? 'today_number' : 'today_number_comma'"
          >
            <transition-group name="list-complete" tag="p">
              <span :key="num" class="list-complete-item">
                {{ num }}
              </span>
            </transition-group>
          </span>
          <span class="today_num_unit">人</span>
        </div>
        <div class="top_left"></div>
        <div class="top_right"></div>
        <div class="bottom_right"></div>
        <div class="bottom_left"></div>
        <div class="top_line"></div>
        <div class="bottom_line"></div>
      </div>
      <div id="chinaMap"></div>
      <div class="view-info-bottom">
        <div class="view-info-item info-item-five">
          <span class="info-item-time">{{ nowTimeBeforeFour }}</span
          ><span>{{ dataJsonInfo.noticeArr[4] }}</span>
        </div>
        <div class="view-info-item info-item-four">
          <span class="info-item-time">{{ nowTimeBeforeThree }}</span
          ><span>{{ dataJsonInfo.noticeArr[3] }}</span>
        </div>
        <div class="view-info-item info-item-three">
          <span class="info-item-time">{{ nowTimeBeforeTwo }}</span
          ><span>{{ dataJsonInfo.noticeArr[2] }}</span>
        </div>
        <div class="view-info-item info-item-two">
          <span class="info-item-time">{{ nowTimeBeforeOne }}</span
          ><span>{{ dataJsonInfo.noticeArr[1] }}</span>
        </div>
        <div class="view-info-item info-item-one">
          <span class="info-item-new"
            ><span class="new-dot"></span
            ><span class="new-tip">最新</span></span
          ><span class="info-item-time">{{ nowTime }}</span
          ><span>{{ dataJsonInfo.noticeArr[0] }}</span>
        </div>
      </div>
    </div>
    <div class="view_right">
      <div class="right-label">
        <img
          class="label-icon"
          src="@/assets/images/common/union.png"
          alt="union"
        />
        <span class="label-text">累计美团外卖骑手极速验证人数/人</span>
      </div>
      <div class="right-total-num">
        <div class="total-num-box">
          <span
            v-for="(rightNum, i) in addCommas(
              dataJsonInfo.meituanVerifyTotalNum
            )"
            :key="rightNum + i"
            :class="rightNum === ',' ? 'num-comma' : 'num-item'"
            >{{ rightNum }}</span
          >
        </div>
        <div class="total-line-box">
          <img
            class="line-icon"
            src="@/assets/images/common/right-total-line.png"
            alt="line"
          />
          <img
            class="line-rider"
            src="@/assets/images/common/right-rider.gif"
            alt="rider"
          />
        </div>
      </div>
      <div class="right-label">
        <img
          class="label-icon"
          src="@/assets/images/common/union.png"
          alt="union"
        />
        <span class="label-text">2021年9月系统上线后各类访客累计总数/人</span>
      </div>
      <div class="right-visitor-box">
        <div
          v-for="right in dataJsonInfo.totalVisitorsArr"
          :key="right.label"
          class="right-visitor-item"
        >
          <div class="visitor-item-label">{{ right.label }}</div>
          <div class="visitor-item-progress">
            <span
              class="progress-width"
              :style="{
                width: (right.value / right.max) * 100 + '%',
                background: right.background
              }"
            ></span>
            <img
              :src="getIcon(right.icon)"
              class="progress-icon"
              alt="visitor-icon"
            />
          </div>
          <div class="visitor-item-num">
            <span class="item-num-text" :style="{ color: right.color }">{{
              addCommas(right.value)
            }}</span
            ><span>万</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view_right_line"></div>
  </div>
</template>
<script>
import axios from 'axios'
import ChinaMap from './mixins/chinaMap'
import dayjs from 'dayjs'
import { handleWeekText } from './reportJs'
var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
export default {
  name: 'report',
  mixins: [ChinaMap],
  data () {
    return {
      dataJsonInfo: {
        meituanVerifyRandom: 3,
        todayMeituanVerifyNum: 0, // 今日美团外卖骑手极速验证人数
        meituanVerifyTotalNum: 0,
        todayVisitorsArr: [], // 今日各类访客数据
        viewData: [], // 地图数据
        noticeArr: [],
        totalVisitorsArr: []
      },
      timer: null,
      nowTime: '',
      nowTimeBeforeOne: '',
      nowTimeBeforeTwo: '',
      nowTimeBeforeThree: '',
      nowTimeBeforeFour: '',
      nowDate: '',
      nowWeek: '',
      echartsTimer: null,
      autoSelectTimer: null
    }
  },
  async mounted () {
    await this.getDataJson()
    document.title = '数据大屏'
    this.applyRemAdjustments()
    this.handleNowTime()
    this.renderPage()
    this.getChinaMap()
    this.initEcharts()
    this.timer = setInterval(() => {
      this.handleNowTime()
      this.renderPage()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.echartsTimer)
    clearInterval(this.autoSelectTimer)
    this.removeRemAdjustments()
  },
  methods: {
    // 接口获取服务端json数据
    async getDataJson () {
      const responseData = await axios({
        method: 'get',
        url: window.location.origin + '/static/data.json'
      })
      this.dataJsonInfo = responseData.data
    },
    // 仅数据大屏页做自适应（单位换算）
    applyRemAdjustments () {
      if (typeof window.remAdjustment === 'undefined') {
        window.remAdjustment = (function flexible (window, document) {
          var docEl = document.documentElement
          var dpr = window.devicePixelRatio || 1

          // adjust body font size
          function setBodyFontSize () {
            if (document.body) {
              document.body.style.fontSize = 12 * dpr + 'px'
            } else {
              document.addEventListener('DOMContentLoaded', setBodyFontSize)
            }
          }
          setBodyFontSize()

          // set 1rem = viewWidth / 10
          function setRemUnit () {
            // var rem = docEl.clientWidth / 10
            // docEl.style.fontSize = rem + 'px'
            var width = docEl.getBoundingClientRect().width
            // 最小1366px，最大适配2560px
            if (width / dpr < 1366) {
              width = 1366 * dpr
              // eslint-disable-next-line sonarjs/elseif-without-else
            } else if (width / dpr > 2560) {
              width = 2560 * dpr
            }
            // 设置成24等份，设计稿时1920px的，这样1rem就是80px
            var rem = width / 24
            docEl.style.fontSize = rem + 'px'
            flexible.rem = window.rem = rem
          }

          setRemUnit()

          // reset rem unit on page resize
          window.addEventListener('resize', setRemUnit)
          window.addEventListener('pageshow', function (e) {
            if (e.persisted) {
              setRemUnit()
            }
          })

          // detect 0.5px supports
          if (dpr >= 2) {
            var fakeBody = document.createElement('body')
            var testElement = document.createElement('div')
            testElement.style.border = '.5px solid transparent'
            fakeBody.appendChild(testElement)
            docEl.appendChild(fakeBody)
            if (testElement.offsetHeight === 1) {
              docEl.classList.add('hairlines')
            }
            docEl.removeChild(fakeBody)
          }
        })(window, document)
      }
    },
    removeRemAdjustments () {
      if (window.remAdjustment) {
        window.remAdjustment = null
        document.documentElement.style.fontSize = ''
      }
    },
    // 渲染echarts
    initEcharts () {
      const color = ['#FFB41F', '#53F6FF', '#3D5FFF', '#47F24B', '#EAFF00']
      let option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            // startAngle: 140, // 起始角度
            name: '',
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['50%', '50%'],
            color,
            left: 40,
            right: 40,
            itemStyle: {
              borderColor: 'rgba(14, 19, 33, 0.9)',
              borderWidth: 3
            },
            avoidLabelOverlap: true,
            minAngle: 20,
            label: {
              show: true,
              formatter: '{a|{a}} {b|{b}}\n{per|{d}%}',
              color: '#fff',
              fontSize: 14,
              fontWeight: 500,
              padding: [20, 2, 2, 2],
              position: 'top',
              rich: {
                a: {
                  width: 7,
                  height: 7,
                  verticalAlign: 'top',
                  borderRadius: 3.5,
                  backgroundColor: 'auto'
                },
                b: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 500,
                  with: '50%'
                },
                per: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 500
                }
              }
            },
            emphasis: {
              itemStyle: {
                borderWidth: 0 // 设置高亮时边界的粗细
                // borderColor: '#fff'
              }
            },
            data: this.dataJsonInfo.todayVisitorsArr
          }
        ]
      }
      const myEcharts = echarts.init(this.$refs.pieEchartsRef)
      this.$nextTick(() => {
        myEcharts.setOption(option)
      })
      window.onresize = function () {
        // 每次窗口大小变化时，都会调用ECharts实例的resize方法
        myEcharts.resize()
      }
      this.echartsTimer = setInterval(() => {
        myEcharts.setOption(option)
      }, 3000)
      this.handleChartLoop(option, myEcharts)
    },

    // echarts自动循环高亮
    handleChartLoop (option1, myChart1) {
      var currentIndex = -1
      this.autoSelectTimer = setInterval(() => {
        var dataLen = option1.series[0].data.length
        currentIndex = (currentIndex + 1) % dataLen
        for (var idx in option1.series[0].data) {
          // 遍历饼图数据，取消所有图形的高亮效果
          myChart1.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: idx
          })
          // 高亮当前图形
          myChart1.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: currentIndex
          })
        }
      }, 3000)
    },

    // 获取实时时间，每秒更新
    handleNowTime () {
      const now = new Date()
      this.nowTime = dayjs(now).format('HH:mm:ss')
      this.nowTimeBeforeOne = dayjs(
        now.setSeconds(now.getSeconds() - 1)
      ).format('HH:mm:ss')
      this.nowTimeBeforeTwo = dayjs(
        now.setSeconds(now.getSeconds() - 1)
      ).format('HH:mm:ss')
      this.nowTimeBeforeThree = dayjs(
        now.setSeconds(now.getSeconds() - 1)
      ).format('HH:mm:ss')
      this.nowTimeBeforeFour = dayjs(
        now.setSeconds(now.getSeconds() - 1)
      ).format('HH:mm:ss')
      this.nowDate = dayjs(now).format('YYYY/MM/DD')
      this.nowWeek = handleWeekText(dayjs(now).format('dd'))
    },
    getImgUrl (type) {
      return {
        wmy: require('@/assets/images/common/middle-wmy.png'),
        kdy: require('@/assets/images/common/middle-kdy.png'),
        aikm: require('@/assets/images/common/middle-aikm.png'),
        zh: require('@/assets/images/common/middle-zh.png'),
        ggqy: require('@/assets/images/common/middle-ggqy.png')
      }[type]
    },
    // 获取地图城市车场数量
    getChinaMap () {
      this.drawMap(this.dataJsonInfo.viewData)
    },

    // 渲染页面数据
    renderPage () {
      const verifyRandom = Math.round(
        Math.random() * this.dataJsonInfo.meituanVerifyRandom
      )
      this.dataJsonInfo.todayMeituanVerifyNum =
        this.dataJsonInfo.todayMeituanVerifyNum + verifyRandom
      this.dataJsonInfo.meituanVerifyTotalNum =
        this.dataJsonInfo.meituanVerifyTotalNum + verifyRandom
      this.dataJsonInfo.noticeArr.unshift(this.dataJsonInfo.noticeArr.pop())
      this.dataJsonInfo.todayVisitorsArr.forEach(item => {
        item.value = item.value + verifyRandom
      })
    },
    // 根据访客类型type获取对应icon地址
    getIcon (type) {
      switch (type) {
        case 'visitor-union':
          return require('@/assets/images/common/visitor-union.png')
        case 'visitor-vector':
          return require('@/assets/images/common/visitor-vector.png')
        case 'visitor-ai':
          return require('@/assets/images/common/visitor-ai.png')
        case 'visitor-invite':
          return require('@/assets/images/common/visitor-invite.png')
        case 'visitor-common':
          return require('@/assets/images/common/visitor-common.png')
      }
    },
    // 数字转换为每三位数字添加一个逗号的格式
    addCommas (num) {
      let numStr = num.toString()
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>
<style lang="less" scoped>
.view_main {
  width: 100%;
  height: 13.5rem;
  flex-shrink: 0;
  background: linear-gradient(180deg, #151c2e 0%, #1c2941 100%);
  position: relative;
  .left_line_move,
  .right_line_move {
    position: absolute;
    width: 7.6875rem;
    top: 0.715rem;
    height: 3px;
    z-index: 99;
    overflow: hidden;
    background: rgba(20, 38, 64, 1);
    &::after {
      position: absolute;
      z-index: 5;
      width: 7.6875rem;
      height: 1px;
      content: "";
      right: 0%;
      bottom: 1px;
      overflow: hidden;
      background: linear-gradient(
        90deg,
        rgba(40, 125, 255, 0) 0%,
        #76ceff 50.42%,
        rgba(40, 125, 255, 0) 94.9%
      );
      animation: panle-line-right 6s ease-in-out infinite;
      animation-delay: -2s;
    }
  }
  .left_line_move {
    left: 0;
  }
  .right_line_move {
    right: 0;
  }
  .view_top {
    width: 100%;
    height: 1.2875rem;
    background: url("~@/assets/images/common/top-bg.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -5px;
    left: 0;
    z-index: 9;
    .top_logo {
      width: 1.275rem;
      height: 0.425rem;
      background: url("~@/assets/images/common/top-logo.svg") no-repeat;
      background-size: 100% 100%;
      margin-top: 0.2125rem;
      margin-left: 0.3rem;
    }
    .top_time {
      display: flex;
      align-items: center;
      justify-content: end;
      padding-right: 0.3rem;
      height: 0.3rem;
      line-height: 0.3rem;
      margin-top: -0.355rem;
      text-align: right;
      color: #a1a8b3;
      .time-text {
        font-size: 0.25rem;
        font-weight: 700;
      }
      .date-text {
        margin-left: 0.125rem;
        margin-right: 0.0875rem;
        font-size: 0.225rem;
        font-weight: 700;
      }
      .week-text {
        font-size: 0.225rem;
        font-weight: 400;
      }
    }
  }
  .view_left_line,
  .view_right_line {
    width: 0.175rem;
    height: 11.95rem;
    background: url("~@/assets/images/common/left_line.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 1.2875rem;
  }
  .view_right_line {
    background: url("~@/assets/images/common/right_line.png") no-repeat;
    background-size: 100% 100%;
    left: inherit;
    right: 0.025rem;
  }
  .china_map {
    width: 12.6375rem;
    height: 100%;
    background-image: url("~@/assets/images/home/cross.png");
    background-repeat: repeat;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    #chinaMap {
      width: 100%;
      height: 13.5rem /* 694/80 */;
      z-index: 1;
    }
    .view_map_top {
      position: absolute;
      top: calc(1.2875rem + 0.225rem);
      left: 50%;
      transform: translateX(-50%);
      width: 6.9625rem;
      height: 2.0125rem;
      background: #0e13218f;
      border-image-source: linear-gradient(
        90deg,
        rgba(118, 206, 255, 0) 0%,
        rgba(118, 206, 255, 0.46) 25.52%,
        #76ceff 50%,
        rgba(118, 206, 255, 0.46) 71.35%,
        rgba(118, 206, 255, 0) 100%
      );

      backdrop-filter: blur(3px);
      padding: 0.2125rem 0 0.25rem;
      .top_bg {
        width: 1.45rem;
        height: 1.9rem;
        background: url("~@/assets/images/common/map-top-today-bg.png")
          no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0.1rem;
        right: 0.45rem;
      }
      .map_top_bg {
        width: 3.475rem;
        height: 0.60625rem;
        background: url("~@/assets/images/common/map-top-bg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0.075rem;
        left: 50%;
        transform: translateX(-50%);
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 1.5px;
          background: linear-gradient(
            270deg,
            rgba(250, 215, 88, 0) -0.3%,
            #fad758 49.52%,
            rgba(250, 215, 88, 0) 100%
          );
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      .today_title {
        width: 100%;
        text-align: center;
        letter-spacing: 0.0625rem;
        font-size: 0.25rem;
        color: rgba(255, 255, 255, 0.85);
      }
      .today_num {
        margin-top: 0.325rem;
        width: 100%;
        height: 0.85rem;
        text-align: center;
        position: relative;
        .today_number {
          font-size: 0.5rem;
          font-weight: 700;
          display: inline-block;
          width: 0.6rem;
          height: 0.85rem;
          line-height: 0.85rem;
          text-align: center;
          color: rgba(249, 208, 5, 1);
          background: url("~@/assets/images/common/number-bg.png") no-repeat;
          background-size: 100% 100%;
          margin-left: 0.15rem;
          font-family: Lato;
          &:first-child {
            margin-left: 0;
          }
        }
        .today_num_unit {
          font-size: 0.225rem;
          color: rgba(255, 255, 255, 0.5);
          display: inline-block;
          height: 0.85rem;
          line-height: 0.85rem;
          vertical-align: top;
          margin-left: 0.2rem;
        }
        .today_number_comma {
          font-size: 0.5rem;
          font-weight: 700;
          color: rgba(249, 208, 5, 1);
          margin-left: 0.15rem;
          font-family: Lato;
          > p {
            display: inline-block !important;
          }
        }
      }
    }
  }
  .view_left,
  .view_right {
    width: 5.225rem;
    height: 11.85rem;
    background-color: #0e1321;
    opacity: 0.9;
    position: absolute;
    left: 0.3rem;
    top: 1.35rem;
  }
  .view_left {
    padding: 0.425rem 0.15rem 0.6rem;
    .left_top {
      width: 100%;
      height: 0.525rem;
      position: relative;
      padding: 0.05rem 0.1625rem 0.1rem;
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border: 0.0875rem solid #0fffbe;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        transform: rotate(135deg);
        top: -0.0875rem;
        left: -0.0875rem;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 0.01875rem;
        background: linear-gradient(
          90deg,
          #114a60 0%,
          rgba(1, 84, 161, 0.0001) 101.02%
        );
        bottom: 0;
        left: 0;
      }
      .left_top_icon {
        width: 0.2375rem;
        height: 0.225rem;
      }
      .left_top_title {
        font-size: 0.25rem;
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 0.0375rem;
        margin-left: 0.1375rem;
      }
    }
    .left_middle {
      width: 4.175rem;
      height: 6.3rem;
      margin-top: 0.475rem;
      margin-left: 0.375rem;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: space-between;
      .middle_item {
        width: calc(50% - 0.225rem);
        height: 1.75rem;
        display: inline-block;
        text-align: center;
        position: relative;
        &:nth-child(2n) {
          margin-left: 0.45rem;
        }
        .item_title {
          width: 100%;
          height: 0.425rem;
          line-height: 0.425rem;
          font-size: 0.2125rem;
          color: rgba(255, 255, 255, 1);
          &.bg-wmy {
            background: linear-gradient(
              90deg,
              rgba(255, 180, 31, 0) 0%,
              rgba(255, 180, 31, 0.6) 48.87%,
              rgba(255, 180, 31, 0) 100%
            );
          }
          &.bg-kdy {
            background: linear-gradient(
              90deg,
              rgba(153, 239, 253, 0) 0%,
              rgba(153, 239, 253, 0.6) 48.87%,
              rgba(153, 239, 253, 0) 100%
            );
          }
          &.bg-aikm {
            background: linear-gradient(
              90deg,
              rgba(61, 95, 255, 0) 0%,
              rgba(61, 95, 255, 0.6) 48.87%,
              rgba(61, 95, 255, 0) 100%
            );
          }
          &.bg-zh {
            background: linear-gradient(
              90deg,
              rgba(16, 246, 0, 0) 0%,
              rgba(50, 215, 54, 0.6) 48.87%,
              rgba(21, 246, 0, 0) 100%
            );
          }
          &.bg-ggqy {
            background: linear-gradient(
              90deg,
              rgba(250, 237, 88, 0) 0%,
              rgba(255, 244, 29, 0.6) 48.87%,
              rgba(250, 215, 88, 0) 100%
            );
          }
        }
        .item_number {
          width: 100%;
          font-size: 0.375rem;
          color: rgba(255, 255, 255, 1);
          margin-top: 0.2875rem;
          z-index: 9;
        }
        .item_bg_img {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.8125rem;
        }
      }
    }
    .left_echarts {
      width: 100%;
      height: 2.8875rem;
      margin-top: 0.6375rem;
      position: relative;
      #pieEchartsRef {
        width: 100%;
        height: 100%;
      }
      .echarts_title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        width: 1.645rem;
        height: 1.645rem;
        background-color: rgba(14, 19, 33, 0.5);
        font-size: 0.175rem;
        color: rgba(255, 255, 255, 0.85);
        text-align: center;
        padding: 0.55rem 0.225rem;
      }
    }
  }
  .view_right {
    position: absolute;
    left: inherit;
    right: 24px;
    top: 1.35rem;
    padding: 0.425rem 0.15rem 0.2rem 0.15rem;
    .right-label {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.525rem;
      .label-icon {
        margin-left: 0.1625rem;
        margin-right: 0.1375rem;
        width: 0.2375rem;
      }
      .label-text {
        font-size: 0.2rem;
        font-weight: 700;
        color: white;
      }
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border: 0.0875rem solid #0fffbe;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        transform: rotate(135deg);
        top: -0.0875rem;
        left: -0.0875rem;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 0.01875rem;
        background: linear-gradient(
          90deg,
          #114a60 0%,
          rgba(1, 84, 161, 0.0001) 101.02%
        );
        bottom: 0;
        left: 0;
      }
    }
    .right-total-num {
      width: 100%;
      height: 3.075rem;
      margin-top: 0.35rem;
      margin-bottom: 0.65rem;
      padding: 0.1rem 0.15rem 0.15rem;
      background: url("~@/assets/images/common/right-total-mask.png") no-repeat;
      background-size: 100% 100%;
      .total-num-box {
        display: flex;
        column-gap: 0.05rem;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 0.6625rem;
        padding: 0.075rem;
        .num-comma {
          font-size: 0.35rem;
          font-weight: 900;
          color: rgba(106, 240, 255, 1);
          padding-bottom: 0.05rem;
        }
        .num-item {
          width: 0.3125rem;
          height: 0.5125rem;
          text-align: center;
          color: rgba(106, 240, 255, 1);
          font-size: 0.35rem;
          font-weight: 900;
          background: rgb(27, 42, 55);
          border: 1px solid rgba(171, 246, 255, 0.1);
        }
      }
      .total-line-box {
        position: relative;
        margin: 0.35rem auto 0;
        width: 3.9rem;
        height: 1.8125rem;
        .line-icon {
          width: 3.2625rem;
        }
        .line-rider {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 1.175rem;
          height: 1.1rem;
        }
      }
    }
    .right-visitor-box {
      margin-top: 0.35rem;
      display: flex;
      flex-direction: column;
      row-gap: 0.15rem;
      .right-visitor-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.2rem;
        width: 100%;
        height: 1.025rem;
        border: 1px solid rgba(4, 153, 239, 0.19);
        border-radius: 0.075rem;
        background: linear-gradient(
          358.35deg,
          #0e2338 1.36%,
          rgba(14, 35, 56, 0) 98.56%
        );
        .visitor-item-label {
          width: 1.2rem;
          font-size: 0.2rem;
          color: rgba(255, 255, 255, 0.85);
        }
        .visitor-item-progress {
          position: relative;
          width: 2.15rem;
          height: 0.175rem;
          margin-left: 0.075rem;
          margin-right: 0.1rem;
          background: #0f1423;
          .progress-width {
            display: inline-block;
            height: 100%;
          }
          .progress-icon {
            position: absolute;
            margin-left: -0.35rem;
            bottom: -0.1rem;
            width: 0.525rem;
          }
        }
        .visitor-item-num {
          flex: 1;
          height: 0.3rem;
          text-align: right;
          color: #878e97;
          .item-num-text {
            margin-right: 0.025rem;
            font-size: 0.225rem;
            font-weight: 600;
          }
        }
      }
    }
  }
  .view-info-bottom {
    position: absolute;
    left: 0.05rem;
    bottom: 0.3rem;
    .view-info-item {
      margin-top: 0.075rem;
      font-size: 0.2125rem;
      padding: 0 24px;
      width: fit-content;
      height: 0.5375rem;
      color: white;
      line-height: 0.5375rem;
      background: #151f34;
      border-radius: 0.26875rem;
    }
    .info-item-one {
      position: relative;
      padding-left: 1.1625rem;
      opacity: 1;
      &::before {
        content: "";
        display: block;
        width: 40%;
        height: 1px;
        background: linear-gradient(
          270deg,
          rgba(250, 215, 88, 0) -0.3%,
          #b4fcff 49.52%,
          rgba(250, 215, 88, 0) 100%
        );
        position: absolute;
        top: 0;
        left: 20%;
      }
      &::after {
        content: "";
        display: block;
        width: 40%;
        height: 1px;
        background: linear-gradient(
          270deg,
          rgba(250, 215, 88, 0) -0.3%,
          #b4fcff 49.52%,
          rgba(250, 215, 88, 0) 100%
        );
        position: absolute;
        bottom: 0;
        right: 20%;
      }
    }
    .info-item-two {
      opacity: 0.6;
    }
    .info-item-three {
      opacity: 0.45;
    }
    .info-item-four {
      opacity: 0.25;
    }
    .info-item-five {
      opacity: 0.1;
    }
    .info-item-time {
      margin-right: 0.2rem;
    }
    .info-item-new {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 0.075rem;
      position: absolute;
      left: 0.125rem;
      top: 0.1rem;
      width: 0.8875rem;
      height: 0.3375rem;
      border-radius: 0.16875rem;
      background: #193d4c;
      .new-dot {
        width: 0.1125rem;
        height: 0.1125rem;
        border-radius: 0.05625rem;
        background: rgba(180, 252, 255, 1);
        box-shadow: 0px 1px 4.3px 0px rgba(180, 252, 255, 0.57);
      }
      .new-tip {
        font-size: 0.1875rem;
        color: #bac4c9;
      }
    }
  }
}
.top_line,
.bottom_line {
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(40, 125, 255, 0) 0%,
    #76ceff 50.42%,
    rgba(40, 125, 255, 0) 94.9%
  );
}
.top_line {
  top: 0;
}
.bottom_line {
  bottom: 0;
}
.top_left,
.top_right,
.bottom_right,
.bottom_left {
  position: absolute;
  width: 8px;
  height: 8px;

  &::before {
    position: absolute;
    background: rgba(118, 206, 255, 1);
    content: "";
  }

  &::after {
    position: absolute;
    background: rgba(118, 206, 255, 1);
    content: "";
  }
}
.bottom_left {
  bottom: 0;
  left: 0;
  &::before {
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
  }

  &::after {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
}
.top_left {
  top: 0;
  left: 0;
  &::before {
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
  }

  &::after {
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
}
.top_right {
  top: 0;
  right: 0;
  &::before {
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
  }

  &::after {
    top: 0;
    right: 0;
    width: 100%;
    height: 2px;
  }
}
.bottom_right {
  bottom: 0;
  right: 0;
  &::before {
    bottom: 0;
    right: 0;
    width: 2px;
    height: 100%;
  }

  &::after {
    bottom: 0;
    right: 0;
    width: 100%;
    height: 2px;
  }
}
.list-complete-item {
  transition: all 0s;
  display: inline-block;
  font-weight: 700;
  // margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(0px);
}
.list-complete-leave-active {
  position: absolute;
}
@keyframes panle-line-right {
  0% {
    right: -100%;
  }

  50% {
    right: 100%;
  }
  100% {
    right: -100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/report.vue